import { computed as m, createElementBlock as l, openBlock as n, normalizeClass as c, createElementVNode as o, renderSlot as g, createCommentVNode as r, createBlock as h, createVNode as u, unref as s } from "vue";
import { screenProp as y } from "../../utils/utilsScreen.js";
import { themeProp as f } from "../../composables/useTheme.js";
/* empty css                   */
import d from "../../atoms/image-element/image-element.vue.js";
const w = { class: "ds-container" }, k = {
  key: 0,
  class: "ds-grid"
}, v = { class: "ds-grid__col" }, N = /* @__PURE__ */ Object.assign({
  name: "DsSectionImage"
}, {
  __name: "section-image",
  props: {
    /**
     * Theme variant
     */
    themeVariant: {
      type: String,
      default: "",
      validator: (e) => e ? ["light-grey", "light-dark", "grey-dark", "grey-light", "dark-light", "dark-grey"].includes(e) : !0
    },
    /**
     * Image
     * @property {Object} image.small - { src: String, name: String }
     * @property {Object} image.medium - { src: String, name: String }
     * @property {Object} image.large - { src: String, name: String }
     */
    image: {
      type: Object,
      default: null,
      validator: (e) => ["small", "medium", "large"].every(
        (a) => a in e && ["src", "name"].every((t) => t in e[a])
      )
    },
    /**
     * Image loading strategy
     */
    lazy: {
      type: Boolean,
      default: !1
    },
    /**
     * Image with shadow
     */
    withShadow: {
      type: Boolean,
      default: !1
    },
    isContained: {
      type: Boolean,
      default: !1
    },
    ...f,
    ...y
  },
  setup(e) {
    const a = e, t = m(() => a.themeVariant || a.theme);
    return (i, z) => (n(), l("section", {
      class: c(["ds-section-image", { [`ds-section-image--${t.value}`]: t.value }]),
      "data-j-background": ""
    }, [
      o("div", w, [
        g(i.$slots, "default", {}, () => [
          e.image && e.isContained ? (n(), l("div", k, [
            o("div", v, [
              u(s(d), {
                image: e.image,
                lazy: e.lazy,
                screen: i.screen,
                "with-shadow": e.withShadow,
                "data-j-image": ""
              }, null, 8, ["image", "lazy", "screen", "with-shadow"])
            ])
          ])) : r("", !0),
          e.image && !e.isContained ? (n(), h(s(d), {
            key: 1,
            image: e.image,
            lazy: e.lazy,
            screen: i.screen,
            "with-shadow": e.withShadow,
            "data-j-image": ""
          }, null, 8, ["image", "lazy", "screen", "with-shadow"])) : r("", !0)
        ])
      ])
    ], 2));
  }
});
export {
  N as default
};
